<button class="btn btn--more" tabindex="0" title="Sluit" modal-close-btn>
    <span>Sluit</span>
    <svg class="svg-icon svg-icon--xs">
        <use href="assets/icons-ui.svg#cross-closed"></use>
    </svg>
</button>
<h2 modal-title>{{ coverageInput?.data?.title }}</h2>
<div modal-content class="modal-body">
    <wuc-tabset tabsetStyle="secondary" [(selectedTabIndex)]="selectedTabIndex">
        <wuc-tabset-item [name]="tab.title" *ngFor="let tab of coverageInput?.data?.tabs">
            <div [innerHTML]="tab.body"></div>
        </wuc-tabset-item>
    </wuc-tabset>
</div>
